import { MessageCircle } from "lucide-react";

const WHATSAPP_URL =
  "https://wa.me/5551997410236?text=Ol%C3%A1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20atendimento%20do%20*Dr%20Yago%20Almeida*.";

export const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-5 z-40 bg-[#25D366]/80 text-white w-10 h-10 flex items-center justify-center rounded-full shadow-sm hover:bg-[#25D366] transition-all duration-300"
      data-testid="whatsapp-button"
      data-wa-location="botao_flutuante"
      aria-label="Falar pelo WhatsApp"
    >
      <MessageCircle size={18} fill="white" />
    </a>
  );
};
